/** Pure helpers of the player (tested): word count as the exam counts it, accents, clock. */

/** Same rule as the server: groups separated by spaces that contain a letter or a digit. */
export function countWords(text: string): number {
  return text
    .split(/\s+/) // \s also matches the no-break spaces (U+00A0, U+202F)
    .filter((word) => /[\p{L}\p{N}]/u.test(word)).length;
}

/** Accents of French that are slow to type on a QWERTY or phone keyboard. */
export const ACCENTS = ["é", "è", "ê", "à", "â", "ç", "ù", "û", "ô", "î", "ï", "ë", "œ"];
export const QUOTES = ["«", "»"];

/** Insert `piece` at the cursor (replacing the selection): new text and new cursor position. */
export function insertAt(
  text: string,
  start: number,
  end: number,
  piece: string,
): { text: string; cursor: number } {
  const from = Math.max(0, Math.min(start, text.length));
  const to = Math.max(from, Math.min(end, text.length));
  return { text: text.slice(0, from) + piece + text.slice(to), cursor: from + piece.length };
}

/** Seconds → « 34:05 » (or « 1:02:03 » past one hour). */
export function clock(seconds: number): string {
  const s = Math.max(0, Math.floor(seconds));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const rest = String(s % 60).padStart(2, "0");
  return h ? `${h}:${String(m).padStart(2, "0")}:${rest}` : `${m}:${rest}`;
}

/** Where the word count stands against the limits of the task. */
export function wordStatus(count: number, limits?: [number, number]): "short" | "ok" | "long" | "none" {
  if (!limits) return "none";
  if (count < limits[0]) return "short";
  if (count > limits[1]) return "long";
  return "ok";
}
